export default __webpack_public_path__ + "static/media/file-powerpoint.442a5c4a.svg";